import React, { useEffect } from 'react';
import AdjustmentForm from '../../../Components/Form/ItemForm/AdjustmentForm';
import FormLayout from '../../../Components/Layout/FormLayout';
import { NewItemAdjustmentIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const AddAdjustments = ({ handleToast }) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t('Items.item_adjustments');
  }, []);

  return (
    <FormLayout
      title={t('Items.item_adjustments')}
      Icon={NewItemAdjustmentIcon}
      closeUrl="/item-adjustments"
      iconstyle="general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <AdjustmentForm
        type="add"
        title={t('Items.create_adjustment')}
        handleToast={handleToast}
      />
    </FormLayout>
  );
};

export default AddAdjustments;
